import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import {
  OG_ALT_TEXT_WARNING,
  OG_ALT_TEXT_PLACEHOLDER,
  OG_DESCRIPTION_WARNING,
  OG_DESCRIPTION_PLACEHOLDER,
  OG_HEADLINE_WARNING,
  OG_HEADLINE_PLACEHOLDER,
  URL_SLUG_WARNING,
  URL_SLUG_PLACEHOLDER,
  SEO_HEADLINE_WARNING,
  SEO_HEADLINE_PLACEHOLDER,
} from "config/constants/editor";

import {
  onBlurSlug,
  onChange,
  onChangeCheckbox,
  onChangeSlug,
  updateFormAt,
  validateFormAsync,
} from "editor/actions/form";

import Label from "components/library/Label";
import TextInput from "components/library/TextInput";
import CharacterCount from "editor/components/CharacterCount";
import SocialImage from "editor/components/SocialImage";
import InputGroup from "editor/components/InputGroup";

import styles from "./SocialSeo.css";

class SocialSeo extends React.Component {
  constructor(props) {
    super(props);
    this.idPrefix = Math.random()
      .toString(36)
      .substring(7);
  }

  getId(field) {
    return `${this.idPrefix}-${field}`;
  }

  render() {
    return (
      <div className={styles.root}>
        <InputGroup
          headerText="Social & SEO"
          inputs={[
            <>
              <div className={styles.justified}>
                <Label htmlFor={this.getId("slug")}>URL slug</Label>
                <CharacterCount
                  count={this.props.form.slug.length}
                  warningLength={URL_SLUG_WARNING}
                />
              </div>
              <TextInput
                id={this.getId("slug")}
                className={classNames(styles.input, "gtm-add-url-slug")}
                placeholder={URL_SLUG_PLACEHOLDER}
                value={this.props.form.slug}
                onChange={this.props.onChangeSlug}
                onBlur={this.props.onBlurSlug}
                disabled={this.props.status.isReadOnly}
                // TODO: standardize passing in help text for inputs
                help={{
                  title: "URL slug",
                  text:
                    'No need to include prepositions, filler words or "scoop" here. Focus on keywords central to the point of the story.',
                }}
              />
            </>,
            <>
              <div className={styles.justified}>
                <Label htmlFor={this.getId("seo_headline")}>SEO headline</Label>
                <CharacterCount
                  count={this.props.form.seo_headline.length}
                  warningLength={SEO_HEADLINE_WARNING}
                />
              </div>
              <TextInput
                id={this.getId("seo_headline")}
                className={classNames(styles.input, "gtm-add-seo-headline")}
                placeholder={SEO_HEADLINE_PLACEHOLDER}
                value={this.props.form.seo_headline}
                onChange={this.props.onChange("seo_headline")}
                disabled={this.props.status.isReadOnly}
              />
            </>,
            <>
              <div className={styles.justified}>
                <Label htmlFor={this.getId("og_headline")}>
                  Social headline
                </Label>
                <CharacterCount
                  count={this.props.form.og_headline.length}
                  warningLength={OG_HEADLINE_WARNING}
                />
              </div>
              <TextInput
                id={this.getId("og_headline")}
                className={classNames(styles.input, "gtm-add-social-headline")}
                placeholder={OG_HEADLINE_PLACEHOLDER}
                value={this.props.form.og_headline}
                onChange={this.props.onChange("og_headline")}
                disabled={this.props.status.isReadOnly}
              />
            </>,
            <>
              <div className={styles.justified}>
                <Label htmlFor={this.getId("og_description")}>
                  Social description*
                </Label>
                <CharacterCount
                  count={this.props.form.og_description.length}
                  warningLength={OG_DESCRIPTION_WARNING}
                />
              </div>
              <TextInput
                className={classNames(
                  styles.input,
                  "gtm-add-social-description"
                )}
                id={this.getId("og_description")}
                placeholder={OG_DESCRIPTION_PLACEHOLDER}
                value={this.props.form.og_description}
                onChange={this.props.onChange("og_description")}
                disabled={this.props.status.isReadOnly}
                error={this.props.form.errors.socialDescription}
              />
            </>,
            <SocialImage
              key="social-image"
              className="gtm-add-social-image"
              getBaseUrl={this.props.getBaseUrl}
              disabled={this.props.status.isReadOnly}
            />,
            <>
              {this.props.form.social_image && (
                <>
                  <div className={styles.justified}>
                    <Label htmlFor={this.getId("og_alt_text")}>
                      Social image alt text
                    </Label>
                    <CharacterCount
                      count={this.props.form.social_image.alt_text.length}
                      warningLength={OG_ALT_TEXT_WARNING}
                    />
                  </div>
                  <TextInput
                    className={classNames(
                      styles.input,
                      "gtm-add-social-alt_text"
                    )}
                    id={this.getId("og_alt_text")}
                    placeholder={OG_ALT_TEXT_PLACEHOLDER}
                    value={this.props.form.social_image.alt_text}
                    onChange={e => {
                      const alt_text = e.target.value;

                      if (alt_text) {
                        this.props.updateFormAt("social_image", {
                          ...this.props.form.social_image,
                          alt_text,
                        });
                      }
                    }}
                    disabled={this.props.status.isReadOnly}
                  />
                </>
              )}
            </>,
          ]}
        />
      </div>
    );
  }
}

SocialSeo.propTypes = {
  form: PropTypes.object.isRequired,
  getBaseUrl: PropTypes.func.isRequired,
  id: PropTypes.string,
  onBlurSlug: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeCheckbox: PropTypes.func.isRequired,
  onChangeSlug: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  updateFormAt: PropTypes.func.isRequired,
  validateFormAsync: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  form: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  onBlurSlug,
  onChange,
  onChangeCheckbox,
  onChangeSlug,
  updateFormAt,
  validateFormAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialSeo);
